
angular.module('tf.directives')

    .directive('multiChart', function() {
    return {
        restrict: 'E',
        templateUrl: "js/components/charts/multi/multiChart.html",
        replace: true,
        scope : {
            fn      : '&',
            options : '=?'
        },

        link : function(scope){

            scope.options = scope.options || {};
            scope.options.type = scope.options.type || 'line';
            scope.options.unit = scope.options.unit || 'day';
            scope.options.colors = ['#4E81BE', '#99BC57', '#F89546', '#9E403F', '#47ACC5', '#6C5083', '#C6D6A9', '#ff9896', '#9467bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5'];
            scope.loading = true;

            scope.pastMonths = "1";

            var fromDate = moment().subtract(scope.pastMonths, 'months');
            // fromDate.setDate(fromDate.getDate()-30);
            scope.options.from_date = scope.options.from_date || fromDate;
            scope.options.to_date = scope.options.to_date || new Date();


            const noDataMessage = "No Data Available";
            scope.noDataMessage = noDataMessage;

            scope.$watchGroup(['options.unit','options.from_date','options.toDate'], function(newData, oldData){
                if(!dataEq(newData, oldData)) {
                    scope.loading = true;
                    scope.fn({
                        //options: {fromDate: scope.options.fromDate, toDate: scope.options.toDate, unit: scope.options.unit}
                        options: scope.options
                    }).then(function (data) {
                        scope.loading = false;
                        scope.data = data;
                        scope.noData = _.isEmpty(data.values);
                        if(scope.noData) scope.noDataMessage = data.error || noDataMessage;

                    });
                }
            });

            scope.$watch('pastMonths', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    scope.options.from_date = moment().subtract(newVal, 'months');
                }
            });

            scope.fn({
                //options: {from_date : scope.options.fromDate, toDate : scope.options.toDate, unit : scope.options.unit}
                options: scope.options
            }).then(function(data){
                scope.loading = false;
                scope.data = data;
                scope.noData = _.isEmpty(data.values);
                if(scope.noData) scope.noDataMessage = data.error || noDataMessage;

            });

            function dataEq(data1, data2){
                //if(data1.project && !data2.project || !data1.project && data2.project){return false;}
                //if(data1.project && data2.project && data1[0].id !== data2[0].id){return false;}
                if(data1[0] !== data2[0]){return false;}
                if(data1[1] !== data2[1]){return false;}
                if(data1[2] !== data2[2]){return false;}

                return true;
            }





        }

    };
});
